module.exports = __webpack_public_path__ + "img/femme.e77cca92.png";